import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./SubscribePage.module.css";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { getTokenApi, loginApi, printLogsApi, subscribeApi, getIPApi, getHeaderEnrichmentApi } from "../Http/http";
import Spinner from "../Components/Spinner";

export default function SubscribePage({
    serviceName = "Gamers Fusion",
    description = "Unlimited access to premium HTML 5 Games: Action, Adventure, Puzzle, and more!",
    optOutText = "To unsubscribe anytime, reply STOP to 12345 or visit /unsubscribe.",
    providerName = "Rainboo Softmate Pvt Ltd",
}) {

    const parallaxRef = useRef(null);

    // Smooth parallax on scroll (GPU-accelerated)
    useEffect(() => {
        const root = parallaxRef.current;
        if (!root) return;

        const layers = root.querySelectorAll("[data-speed]");
        let ticking = false;

        const onScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                const y = window.scrollY || window.pageYOffset;
                layers.forEach((el) => {
                    const speed = parseFloat(el.getAttribute("data-speed") || "0.2");
                    el.style.transform = `translate3d(0, ${y * speed}px, 0)`;
                });
                ticking = false;
            });
        };

        // Initial position + scroll listener
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const [headerMsisdn, setHeaderMsisdn] = useState(null);
    const [loading, setLoading] = useState(true);
    const [subscribeLoading, setSubscribeLoading] = useState(false);
    const [error, setError] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            navigate("/home");
        }
    }, []);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const getToken = async () => {
        try {
            setLoading(true);
            const response = await axios.post(getTokenApi);
            console.log(response, 'response...');
            fetchMsisdn(response?.data?.token);
            // after getting the token hit the getMsisdn api....
        } catch (error) {
            setLoading(false);
            if (error?.response?.status == 403) {
                console.log("Msisdn not found!");
            }
            else {
                setError(true);
            }
            console.log(error, 'error');
        }
    }

    const fetchMsisdn = async (token) => {
        try {

            const response = await axios.get(
                getHeaderEnrichmentApi,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "X-App": "he-partner",
                        // "X-MessageID": "1234",
                        // "X-Source-System": "he-partner",
                    },
                }
            );

            console.log("Response Data:", response.data);

            const {
                Authorization,
                'Content-Type': contentType,
                'X-App': xApp,
                'X-Source-System': xSourceSystem,
                'x-messageid': xMessageId,
                url,
            } = response.data?.body;

            const secondResponse = await axios.get(url, {
                headers: {
                    Authorization,
                    'Content-Type': contentType,
                    'X-App': xApp,
                    'X-Source-System': xSourceSystem,
                    'x-messageid': xMessageId,
                },
            });

            console.log("MSISDN Response:", secondResponse.data);

            let numberFromHeader = secondResponse?.data?.ServiceResponse?.ResponseBody?.Response?.Msisdn;
            // if (numberFromHeader) {
            //     setHeaderMsisdn(numberFromHeader);
            // }

            const response2 = await axios.post(printLogsApi, {
                apiResponse: response.data,
                apiResponse2: JSON.stringify(secondResponse.data)
            });

            console.log(response2, 'respons2...');

            if (numberFromHeader) {
                setHeaderMsisdn(numberFromHeader);
                await handleLogin(numberFromHeader);
            }

            setLoading(false);
            setError(false);

        } catch (error) {
            setLoading(false);
            console.error("API Error:", error);

            if (error?.response?.status == 403) {
                console.log("Msisdn not found!");
            }
            else {
                setError(true);
            }

            const response2 = await axios.post(printLogsApi, {
                apiError: error?.response?.data?.header ?? error
            });
            console.log(response2, 'response')
        }
    }

    const handleSubscription = async () => {
        try {
            if (headerMsisdn?.trim().length > 0) {

                setSubscribeLoading(true);

                const responseIP = await axios.get(getIPApi);
                const response = await axios.post(subscribeApi, {
                    msisdn: headerMsisdn,
                    ext_ref: extRef,
                    ip_address: responseIP?.data?.ip
                });

                console.log(response, 'response...');

                const response2 = await axios.post(printLogsApi, {
                    apiRequest: {
                        msisdn: headerMsisdn,
                        ext_ref: extRef,
                        ip_address: responseIP?.data?.ip
                    },
                    apiResponse: JSON.stringify(JSON.stringify(response.data)),
                });
                console.log(response2, 'respons2...');

                let message = response?.data?.result?.message;
                let result = response?.data?.result;

                if (message == "User Already Exist" || result == 2) {
                    Cookies.set('msisdn', headerMsisdn, { expires: 1 });
                    navigate("/home");
                    return;
                }

                setSubscribeLoading(false);

                let redirect_url = response?.data?.result?.cg_url;
                if (redirect_url) {
                    window.location.href = redirect_url
                }
                else {
                    toast.error('Redirect url not found!');
                }

            }
            else {
                toast.error("Failure in subscription, Due to invalid msisdn from Header Enrichment!");
                return;
            }

        } catch (error) {
            console.log(error, 'error---');
            setSubscribeLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || "Something Went Wrong!");
        }
    }

    const handleLogin = async (henumber) => {
        try {
            const response = await axios.post(loginApi, {
                msisdn: henumber,
                ext_ref: extRef,
            });

            console.log(response, 'response...');
            setLoading(false);
            Cookies.set('msisdn', henumber, { expires: 1 });
            navigate("/home");
        } catch (error) {
            console.log(error, 'error---');
        }
    }

    useEffect(() => {
        getToken();
    }, []);

    console.log(error, 'error code--');

    return (
        <>

            <div className={styles.page}>
                {/* Parallax Hero */}
                <div ref={parallaxRef} className={styles.heroWrap}>
                    <div className={`${styles.layer} ${styles.stars}`} data-speed="0.15" />
                    <div className={`${styles.layer} ${styles.pixels}`} data-speed="0.25" />
                    <div className={`${styles.layer} ${styles.planets}`} data-speed="0.35" />
                    <header className={styles.hero}>
                        <div className={styles.brandRow}>
                            <span className={styles.badge}>★</span>
                            <h1 className={styles.title}>
                                {serviceName}
                                <span className={styles.sub}>HTML 5 Gaming Portal</span>
                            </h1>
                        </div>
                        <p className={styles.tagline}>{description}</p>
                        <ul className={styles.perks}>
                            <li>30+ kids games</li>
                            <li>No ads inside portal</li>
                        </ul>
                    </header>
                </div>

                {/* Main Card */}
                <main className={styles.main}>

                    <div className={styles.landingPageBanner}>
                        <img src="/assets/banner.gif" alt="Banner" className={styles.banner} />
                    </div>

                    <section className={styles.card}>
                        {(!loading && error) ? (
                            <div className={styles.alert}>
                                <p className={styles.alert_text}>Something Went Wrong! Please Refresh the Page and Try Again!</p>
                            </div>
                        ) : !loading && headerMsisdn ?
                            (
                                <>
                                    <div className={styles.cardHeader}>
                                        <h2 className={styles.cardTitle}>Subscribe Now</h2>
                                    </div>

                                    <div className={styles.grid}>
                                        <div className={styles.block}>
                                            <button
                                                className={styles.cta}
                                                onClick={handleSubscription}
                                            >
                                                Subscribe
                                            </button>

                                            <p className={styles.safeNote}>
                                                KSH 15/day
                                            </p>
                                        </div>
                                    </div>
                                </>
                            ) : !loading && !headerMsisdn ? (
                                <div className={styles.alert}>
                                    <p className={styles.alert_text}>Turn off Wifi and Switch to Safaricom Network to Subscribe the Service.</p>
                                </div>
                            ) : null}

                        <div className={styles.center_button}>
                            <button className={styles.loginLink} onClick={() => navigate(`/login?ext_id=${extRef}`)}>
                                Already a Subscriber, Login
                            </button>
                        </div>
                    </section>

                    <section className={styles.infoGrid}>

                        <article className={styles.infoCard}>
                            <h4>Terms & Conditions</h4>
                            <ul className={styles.features}>
                                <li>
                                    The service cost is KSH 15/day.
                                </li>
                                <li>
                                    Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.
                                </li>
                                <li>
                                    You can unsubscribe from the service anytime, by dialling USSD code *xxx# or deactivating from the portal.
                                </li>
                                <li>
                                    All data-enabled features & Smartphone users can enjoy full service.
                                </li>
                                <li>
                                    Customer can access the content at any time during the subscription validity period.
                                </li>
                            </ul>
                        </article>

                        <article className={styles.infoCard}>
                            <h4>What you get</h4>
                            <ul className={styles.features}>
                                <li>Unlimited access to the kids games</li>
                                <li>30+ Games — play instantly</li>
                                <li>Top Categories — action, adventure, puzzle, arcade and more</li>
                                <li>No Ads — play instantly</li>
                            </ul>
                        </article>



                        {/* <article className={styles.infoCard}>
                            <h4>Provider</h4>
                            <p>
                                Service by <strong>{providerName}</strong>.
                            </p>
                        </article> */}
                    </section>
                </main>

                {/* <footer className={styles.footer}>
                    <p>
                        © {new Date().getFullYear()} {providerName}. All rights reserved.
                    </p>
                </footer> */}
            </div>

            {loading &&
                <div className={styles.full_screen_loader_container}>
                    <Spinner />
                    <p className={styles.loader_text}>Loading Please Wait...</p>
                </div>
            }
        </>
    );
}
